export class PitrRestoreWindow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "earliest",
            "baseName": "earliest",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "latest",
            "baseName": "latest",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return PitrRestoreWindow.attributeTypeMap;
    }
    constructor() {
    }
}
